import type { PromptTemplate, PromptTemplateCategory } from '../../api';
import PromptCard from '../PromptCard';
import styles from './PromptGrid.module.scss';

interface PromptGridProps {
  prompts: PromptTemplate[];
  selectedCategory: PromptTemplateCategory | null;
  onUsePrompt: (content: string) => void;
  onApplyToAiSettings?: (content: string) => void;
  onEditPrompt?: (prompt: PromptTemplate) => void;
  onDeletePrompt?: (prompt: PromptTemplate) => void;
  currentUserId?: string | null;
}

export default function PromptGrid({
  prompts,
  selectedCategory,
  onUsePrompt,
  onApplyToAiSettings,
  onEditPrompt,
  onDeletePrompt,
  currentUserId,
}: PromptGridProps) {
  const filtered =
    selectedCategory === null
      ? prompts
      : prompts.filter((p) => p.categories?.some((c) => c.id === selectedCategory.id));

  if (filtered.length === 0) {
    return (
      <div className={styles.root}>
        <div className={styles.empty}>
          <p>Нет шаблонов промптов</p>
          <p className={styles.emptyHint}>
            {selectedCategory
              ? `В категории «${selectedCategory.title}» пока пусто`
              : 'Добавьте первый промпт, нажав «Создать промпт»'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      {filtered.map((prompt) => (
        <PromptCard
          key={prompt.id}
          prompt={prompt}
          onUse={onUsePrompt}
          onApplyToAiSettings={onApplyToAiSettings}
          onEdit={onEditPrompt}
          onDelete={onDeletePrompt}
          isOwn={!!currentUserId && prompt.created_by === currentUserId}
        />
      ))}
    </div>
  );
}
